import { all, call, put, takeEvery } from 'redux-saga/effects';
import { requestApiSaga } from 'b2b-apps/shop/common/redux/api/sagas';
import { reportError } from 'b2b-apps/shop/common/redux/errors/actionCreators';
import { parseError } from 'b2b-apps/shop/common/utils/api/error';
import { CollectionEntries } from 'b2b-apps/shop/content/api/CollectionEntries';
import {
  fetchContentCollectionEntryFulfilled,
  fetchContentCollectionEntryRejected,
} from 'b2b-apps/shop/content/redux/contentCollectionsEntries/actionCreators';
import { FETCH_CONTENT_COLLECTION_ENTRY } from 'b2b-apps/shop/content/redux/contentCollectionsEntries/actionTypes';
import { FetchContentCollectionEntryAction } from 'b2b-apps/shop/content/redux/contentCollectionsEntries/types';

function* fetchContentCollectionEntrySaga(
  action: FetchContentCollectionEntryAction,
): Generator<any, any, any> {
  const { collectionId, entryId } = action.payload;

  try {
    const response = yield call(
      requestApiSaga,
      CollectionEntries.fetch(collectionId, {
        slug: entryId,
      }),
    );
    yield put(
      fetchContentCollectionEntryFulfilled(
        collectionId,
        entryId,
        CollectionEntries.mapResponseToState(response),
      ),
    );
  } catch (error) {
    yield put(
      fetchContentCollectionEntryRejected(
        collectionId,
        entryId,
        parseError(error),
      ),
    );
    yield put(reportError(action.type, error, action.payload));
  }
}

function* contentCollectionsEntriesSaga(): Generator<any, any, any> {
  yield all([
    takeEvery(FETCH_CONTENT_COLLECTION_ENTRY, fetchContentCollectionEntrySaga),
  ]);
}

export {
  contentCollectionsEntriesSaga,
};
